export const regular = {
  email: /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/
}



// WEBPACK FOOTER //
// ./src/utils/regular.js